@import '../../../node_modules/@cpt/pci/postnl-styles/settings';
@import '../../../node_modules/@cpt/pci/postnl-styles/document';
@import '../../../node_modules/@cpt/pci/postnl-styles/components/flyout';
@import '../../assets/styles/variables';
@import '../../assets/styles/typography';
@import 'pci-checkbox';
@import 'pci-inner-container';

.pci-modal {
    .pnl-cookie-wall & {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        position: fixed;
        z-index: 999999;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.2);
        font-family: 'Post-sans', sans-serif;
    }
}

.pci-modal__body {
    .pnl-cookie-wall & {
        overflow: auto;
        font-weight: 300;
        padding: 1em 1.5em;
    }
}

.pci-modal__body-inner {
    p {
        .pci-link,
        a {
            color: $blue;
            font-weight: 300;
            text-decoration: underline;
        }
    }
}

.pci-modal__content {
    .pnl-cookie-wall & {
        width: 100%;
        max-width: 25.4375em;
        height: fit-content;
        max-height: 96vh;

        display: flex;
        text-align: left;
        position: fixed;
        flex-direction: column;
        border-radius: 0.5em;
        background-color: $white;

        @media (max-width: 57em) {
            max-width: 100vw;
            height: 100vh;
            max-height: 100vh;
            border-radius: 0;
        }

        @media (max-width: 20em) {
            width: 100vw;
            max-width: 100vw;
            height: 100vh;
            max-height: 100vh;
            border-radius: 0;
        }

        &.wide {
            @media (min-width: 57em) {
                max-width: 600px;
            }
        }

        &.settings {
            width: 100%;
            height: 100%;
            min-width: 100%;
            min-height: 100%;
            overflow: auto;

            h1,
            .h1 {
                color: $dark-blue;
                font-weight: 300;
                margin-bottom: 10px;
                font-size: 43px;
                line-height: 52px;
            }

            h2 {
                color: $orange;
                font-weight: 400;
                font-size: 28px;
                line-height: 36px;
                margin-bottom: 16px;
            }

            p {
                margin: 0;
                font-weight: 300;
            }

            .pci-checkbox__label {
                margin-bottom: 0.5rem;
            }
        }
    }
}

.pci-modal__footer {
    .pnl-cookie-wall & {
        position: relative;
        margin-top: auto;
        padding: 1em 1.5em 1.5em;

        @media (max-width: 57em) {
            &::before {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                height: 100px;
                top: -100px;
                background: linear-gradient(
                    180deg,
                    rgba(255, 255, 255, 0) -33.91%,
                    $white 81.9%
                );
            }
        }
    }
}

.pnl-cookie-wall {
    h1,
    .h1 {
        color: $orange;
        font-weight: 400;
        font-size: 28px;
        line-height: 36px;
        margin-block-start: 1em;
        margin-block-end: 1rem;
    }
}

.pci-cookie-button-container {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;

    @media (min-width: 37.5em) {
        display: flex;
        flex-direction: column;

        gap: 1em;
        justify-content: flex-start;
    }

    .settings & {
        gap: unset;
        flex-direction: row;
    }

    .pci-button {
        border-radius: 20px;
        box-sizing: border-box;
        font-family: 'Post-Sans', sans-serif;
        transition: none;

        &.pci-button--primary {
            color: $white;
            background-color: $blue;
        }

        &.pci-button--secondary {
            color: $blue;
            background-color: $white;
            border: 1px solid $blue;
            box-shadow: none;

            &:hover {
                text-decoration: underline;
                text-underline-offset: 0.15em;
                background-color: $white;
            }

            &:active {
                color: $color-white;
                background-color: $color-border-focus-outline;
                text-decoration: underline;
                text-underline-offset: 0.15em;
            }

            &:focus:not(:focus-visible) {
                outline: none;
            }

            &:focus-visible {
                box-shadow: none;
                outline-color: $color-border-focus-outline;
                outline-style: solid;
                outline-width: 2px;
                outline-offset: 1px;
            }
        }
    }
}

.pci-cookie-button-inner {
    inline-size: 100%;
    display: flex;
    flex-direction: column;
    margin-block-start: 1.5rem;

    @media only screen and (min-width: 37.5em) {
        margin-left: auto;
        inline-size: unset;
        gap: 1em;
        justify-content: flex-start;
        flex-direction: row-reverse;
    }
}

pnl-language-selector {
    display: flex;

    .pnl-language-selector {
        margin-left: auto;
    }

    .pci-flyout__trigger {
        color: $color-blue;

        &:hover {
            color: $color-blue;
        }
    }
}

.pci-checkbox__ul {
    list-style-type: none;
    padding: 0;
}

.pci-checkbox__li {
    margin-bottom: 2em;
    margin-block-end: 2em;

    > p {
        font-weight: 300;
    }
}

h4 {
    .pci-checkbox__li & {
        margin: 0;
        font-size: 1em;
        font-weight: 400;
    }
}

ul.pci-flyout__list {
    padding: 1em;
}

@media (max-width: 57em) {
    .whitespace {
        height: 80px;
    }
}

.pci-consent__paragraph {
    margin-bottom: 24px;
}

// Align cookiewidget actionbuttons for mobile and desktop
@media only screen and (max-width: 600px) {
    .pci-widget-actions {
        margin-bottom: 12px;
    }
}

.pci-button {
    .pnl-cookie-wall & {
        width: unset;
    }
}

.stamp-button {
    .pnl-cookie-wall & {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        column-gap: 0.5rem;
        max-inline-size: 100%;
        cursor: pointer;
        padding-block: 0.5rem;
        border-style: solid;
        border-width: 1px;
        font-family: 'Post-Sans', sans-serif;
        font-weight: 700;
        line-height: 1.4;
        font-size: 1rem;
        text-decoration: none;
        border: none;
        background: none;
        color: $color-blue;
        cursor: pointer;
        border-radius: 4px;

        &:active {
            background-color: #ffffff00;
            border-color: #ffffff00;
            color: $color-border-focus-outline;
        }

        &:hover {
            text-decoration: underline;
        }

        &:focus {
            outline: none;
        }

        &:focus-visible {
            outline-color: $color-border-focus-outline;
            outline-style: solid;
            outline-width: 2px;
            outline-offset: 1px;
        }

        &--tertiary {
            background-color: #ffffff00;
            border-color: #ffffff00;
            border-radius: 0.25rem;

            &:hover {
                color: $color-blue;
            }
        }
    }
}

.stamp-button__chevron {
    display: flex;
    align-items: center;
}

.pci-button--secondary {
    box-shadow: none;
}
